"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderContent = void 0;
var react_1 = __importStar(require("react"));
var graphql_tag_1 = __importDefault(require("graphql-tag"));
var client_1 = require("@apollo/client");
var Content_1 = __importDefault(require("./Content"));
var react_dom_1 = __importDefault(require("react-dom"));
var QUERY = graphql_tag_1.default(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query ContentLoaderQuery($tag: String) {\n    content(tag: $tag)\n  }\n"], ["\n  query ContentLoaderQuery($tag: String) {\n    content(tag: $tag)\n  }\n"])));
var ContentLoader = function (props) {
    var _a = client_1.useQuery(QUERY, {
        variables: {
            tag: props.tag,
        },
    }), loading = _a.loading, error = _a.error, data = _a.data, refetch = _a.refetch, fetchMore = _a.fetchMore;
    if (error)
        return react_1.default.createElement("div", null, error.message);
    if (loading)
        return react_1.default.createElement(react_1.default.Fragment, null);
    return react_1.default.createElement(Content_1.default, { content: data.content });
};
exports.default = ContentLoader;
var renderContent = function (apolloClient) {
    var contentElements = document.getElementsByClassName('aperza-content');
    if (contentElements) {
        var elementsArray = Array.from(contentElements);
        elementsArray.forEach(function (element) {
            react_dom_1.default.render(react_1.default.createElement(client_1.ApolloProvider, { client: apolloClient },
                react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement("div", null) },
                    react_1.default.createElement(ContentLoader, { tag: element.getAttribute('data-tag') }))), element);
        });
    }
};
exports.renderContent = renderContent;
var templateObject_1;
